module.exports = __webpack_public_path__ + "static/media/man.a43a93af.jpg";